<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="unit_page.list_title" />

    <UnitList
      :units="filteredUnits"
      :search-query="searchQuery"
      :pagination-config="paginationConfig"
      @update:search-query="searchQuery = $event"
      @create="openCreateModal"
      @edit="openEditModal"
      @delete="deleteUnit"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />

    <CreateUnitModal
      :open="showModal"
      :is-edit="!!selectedUnit"
      :form="form"
      :errors="errors"
      :loading="loading"
      @close="closeModal"
      @save="saveUnit"
      @generate-code="generateUnitCode"
      @update-field="updateField"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import CreateUnitModal from "../../components/Settings/UnitList/CreateUnitModal.vue";
import UnitList from "../../components/Settings/UnitList/UnitList.vue";
import { useUnit } from "../../composables/useUnit";

const {
  searchQuery,
  filteredUnits,
  showModal,
  selectedUnit,
  form,
  errors,
  loading,
  paginationConfig,
  fetchUnits,
  openCreateModal,
  openEditModal,
  closeModal,
  updateField,
  generateUnitCode,
  saveUnit,
  deleteUnit,
} = useUnit();

onMounted(fetchUnits);
</script>
